import { render, staticRenderFns } from "./TaskAssignComponent.vue?vue&type=template&id=cef75ae8&scoped=true&"
import script from "./TaskAssignComponent.vue?vue&type=script&lang=js&"
export * from "./TaskAssignComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskAssignComponent.vue?vue&type=style&index=0&id=cef75ae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef75ae8",
  null
  
)

export default component.exports